<script lang="ts" setup>
// #上三張等寬圖片
import { type Image } from '@/utils/types/Image'
const props = defineProps({
  data: {
    type: Object
  }
})

const imgData1 = ref()
const imgData2 = ref()
const imgData3 = ref()

if (props.data) {
  const img1: Ref<Image> = ref(props.data.image_lft)
  const img2: Ref<Image> = ref(props.data.image_mid)
  const img3: Ref<Image> = ref(props.data.image_rgt)
  imgData1.value = img1.value
  imgData2.value = img2.value
  imgData3.value = img3.value
}
</script>

<template>
  <div class="area">
    <figure class="area__pic area__pic1">
      <Nimg :src="imgData1?.link" :title="imgData1?.title" :alt="imgData1?.alt" format="webp" />
    </figure>
    <figure class="area__pic area__pic2">
      <Nimg :src="imgData2?.link" :title="imgData2?.title" :alt="imgData2?.alt" format="webp" />
    </figure>
    <figure class="area__pic area__pic3">
      <Nimg :src="imgData3.link" :title="imgData3.title" :alt="imgData3.alt" format="webp" />
    </figure>
  </div>
</template>

<style lang="scss" scoped>
.area {
  display: flex;
  justify-content: space-between;
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  img {
    display: block;
    width: 100%;
  }

  &__pic {
    width: calc((100% - toRem(44)) / 3);

    @include max-media(480) {
      width: 33.333%;
    }
  }

  &__pic1 {
    &::after {
      content: '';
      display: block;
      width: 100%;
      padding-top: 100%;

      @include min-media(481) {
        display: none;
      }
    }
  }

  &__pic2 {
    margin-top: 23%;

    @include max-media(480) {
      margin-top: auto;
    }
  }
}
</style>
